module.exports = __webpack_public_path__ + "static/news3-8dd065235de42e3836bef9fceb052f95.jpg";